import * as React from 'react';
import { INCA_DEMO_BOOK_URL } from '@nexxt/common/constants';
export interface ICTAProps {
    content?: string;
    condensed?: boolean;
}

const CTA: React.FC<ICTAProps> = ({
    content = 'Like what you’re seeing? Contact us on how to launch your next study or customize the solution for your needs.',
    condensed = false
}) => (
    <div className={`cta-container ${condensed ? '--condensed' : ''}`}>
        <div className={`cta ${condensed ? '--condensed' : ''}`}>
            <div className="cta-content">{content}</div>
            <div className={`cta-actions ${condensed ? 'mt-2' : ''}`}>
                {/* <button className="btn btn--xs">Close</button> */}
                <a href={INCA_DEMO_BOOK_URL} className="btn btn--xs btn-dark">
                    Book a Demo
                </a>
            </div>
        </div>
    </div>
);

export default CTA;
